module.exports = __webpack_public_path__ + "static/img/bottom.1baadb73.png";